<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard>
          <MatrizLista
            idTipoOpex="1"
            tipoOpex="camp"
            nombreTipoOpex="Campo"
            vAuthAcl="gh-pres-opex-campo"
            v-auth-acl="'gh-pres-opex-campo'"
          ></MatrizLista>
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'OpexCampo',
  components: {
    MatrizLista: () => import('../../components/MatrizLista')
  },
  data: () => ({
    page: {
      title: 'OPEX Campo'
    },
    breadcrumbs: [
      {
        text: 'Presupuesto',
        disabled: true
      },
      {
        text: 'OPEX Campo',
        disabled: false
      }
    ]
  }),
  methods: {
    open() {},
    close() {}
  }
};
</script>
